import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mode } from '../../types';
import { ModeToggle } from './ModeToggle';
import { Button } from '../ui/Button';
import { Menu, X } from 'lucide-react';
import { cn } from '../../lib/utils';
interface NavigationProps {
  mode: Mode;
  setMode: (mode: Mode) => void;
}
export function Navigation({
  mode,
  setMode
}: NavigationProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const businessLinks = [{
    label: 'Products',
    href: '#products'
  }, {
    label: 'Solutions',
    href: '#solutions'
  }, {
    label: 'Developers',
    href: '#developers'
  }];
  const individualLinks = [{
    label: 'Features',
    href: '#'
  }, {
    label: 'How It Works',
    href: '#'
  }, {
    label: 'Pricing',
    href: '#'
  }, {
    label: 'Support',
    href: '#'
  }];
  const links = mode === 'business' ? businessLinks : individualLinks;
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b', isScrolled ? 'bg-white/80 backdrop-blur-md border-slate-200 py-3' : 'bg-white border-transparent py-5')} data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="flex items-center justify-between" data-id="element-111">
          {/* Left Side: Logo + Nav */}
          <div className="flex items-center gap-8" data-id="element-112">
            <a href="#" className="flex items-center gap-2 font-bold text-lg sm:text-xl tracking-tight text-slate-900" data-id="element-113">
              <div className="w-5 h-5 sm:w-6 sm:h-6 bg-slate-900 rounded-sm" data-id="element-114" />
              Obseq
            </a>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-6" data-id="element-115">
              <AnimatePresence mode="wait" data-id="element-116">
                <motion.div key={mode} initial={{
                opacity: 0,
                y: -5
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 5
              }} transition={{
                duration: 0.2
              }} className="flex items-center gap-6" data-id="element-117">
                  {links.map(link => <a key={link.label} href={link.href} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-118">
                      {link.label}
                    </a>)}
                </motion.div>
              </AnimatePresence>
            </nav>
          </div>

          {/* Right Side: Toggle + CTA Button */}
          <div className="hidden md:flex items-center gap-4" data-id="element-119">
            <ModeToggle mode={mode} onToggle={setMode} data-id="element-120" />
            {mode === 'business' ? <a href="mailto:sales@obseq.xyz" data-id="element-121">
                <Button variant="primary" size="sm" data-id="element-122">
                  Talk to Sales
                </Button>
              </a> : <Button variant="primary" size="sm" data-id="element-123">
                Join Waitlist
              </Button>}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-124">
            <ModeToggle mode={mode} onToggle={setMode} data-id="element-125" />
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 text-slate-600 hover:text-slate-900" data-id="element-126">
              {mobileMenuOpen ? <X size={24} data-id="element-127" /> : <Menu size={24} data-id="element-128" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-129">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-slate-100 overflow-hidden" data-id="element-130">
            <div className="px-4 py-6 space-y-4" data-id="element-131">
              {links.map(link => <a key={link.label} href={link.href} className="block text-base font-medium text-slate-600 hover:text-slate-900" data-id="element-132">
                  {link.label}
                </a>)}
              <div className="pt-4" data-id="element-133">
                {mode === 'business' ? <a href="mailto:sales@obseq.xyz" className="block" data-id="element-134">
                    <Button className="w-full" data-id="element-135">
                      Talk to Sales
                    </Button>
                  </a> : <Button className="w-full" data-id="element-136">
                    Join Waitlist
                  </Button>}
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}